import { BaseDropdown } from './component/BaseDropdown';
import { useDropdownOptions } from '../../hooks/useDropdownOptions';
import { BusinessDropdownProps } from './component/type';

const COLUMN_NAMES: string[] = ['Code', 'Description'];

export const CostCentresDropdown = (props: BusinessDropdownProps) => {
  const shouldPreventApiCall = props.disabled || props.readOnly;

  const { options: costCentreOptions, loading } = useDropdownOptions({
    apiId: 'internal.v1.base-tables',
    operationId: 'GET /promptValues/{windowId}',
    labelAttribute: 'locationOwnerGroup',
    valueAttribute: 'costCentre',
    params: {
      windowId: 'costCentres',
    },
    shouldPreventApiCall,
  });

  return <BaseDropdown {...props} loading={loading} options={costCentreOptions} columnNames={COLUMN_NAMES} />;
};
